import * as React from "react";

function Notification({width=24,height=24,...props}) {
  return (
    <svg width={width} height={height} viewBox="0 0 20 22" fill="none" {...props}>
      <path
        d="M18.538 14.516c-.5-.667-1.084-1.334-1.418-2.085-.667-1.501-.75-3.17-.834-4.838-.083-.834-.167-1.668-.417-2.419-.75-2.335-3.086-4.087-5.505-4.17-2.67-.083-5.172 1.168-6.09 3.503a7.225 7.225 0 00-.5 2.67c-.166 2.752-.333 5.504-2.502 7.673-.584.584-.167 1.335.667 1.418H17.87c.418 0 .835-.084 1.085-.584.167-.5-.167-.75-.417-1.168zM12.2 18.937c-.501.667-1.252 1-2.17 1.084-.917-.083-1.668-.417-2.252-1.168"
        stroke="var(--color-blue-500)"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Notification;
